import { render } from "./RemittanceStatistics.vue?vue&type=template&id=07f23868&scoped=true"
import script from "./RemittanceStatistics.vue?vue&type=script&lang=js"
export * from "./RemittanceStatistics.vue?vue&type=script&lang=js"

import "./RemittanceStatistics.vue?vue&type=style&index=0&id=07f23868&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f23868"]])

export default __exports__